/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: VarInput.tsx
 * Project: mle-client
 * Committed last: 2021/11/6 @ 1132
 * ---
 */

import { useState } from 'react';
import {
  Button,
  FormGroup,
  IconName,
  InputGroup,
  Intent
}                   from '@blueprintjs/core';
import {
  InputVariable
}                   from '../store/observables/Editor';

interface VarInputProps {
  inputVariable: InputVariable;
  onConfirm: (inputVariable: InputVariable) => void;
}

export const VarInput = (props: VarInputProps) => {
  const [ value, setValue ] = useState<string>(props.inputVariable.value);
  const [ saved, setSaved ] = useState(false);

  return (
    <FormGroup
      label={ props.inputVariable.name }
    >
      <InputGroup
        leftIcon={ value && saved ? 'small-tick' : 'small-cross' as IconName }
        intent={ value && saved ? Intent.SUCCESS : Intent.NONE }
        className="inline-block"
        value={ value }
        onChange={ ({ target }) => {
          setSaved(false);
          setValue(target.value);
        } }
      />
      {
        value && !saved &&
        <Button
          className="inline-block ml-2"
          minimal
          icon="tick"
          intent={ Intent.PRIMARY }
          onClick={ () => {
            props.onConfirm({
              name: props.inputVariable.name,
              value
            });
            setSaved(true);
          }
          }
        >Applica</Button>
      }
    </FormGroup>
  );
};
